import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";

class delivererDataAccess {
  delivererList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "Deliverer/getAll",
      parameters
    );
  };
  // getIncidentInfo = async (params: { id: number | bigint }) => {
  //   var result = await commonDataAccess.getData(
  //     "incident/get/incidentInfo/" + params,
  //     {}
  //   );
  //   return result;
  // }
  // getIncidentIssuesDropdowns = () => {
  //   return commonDataAccess.getData("incident/get/incidentIssuesDropdown");
  // }
  // getIncidentDropdowns = () => {
  //   return commonDataAccess.getData("incident/get/incidentsDropdown");
  // }
  // saveIncidentInfo = async (data: any) => {
  //   var result = await commonDataAccess.postData(
  //     "incident/save/incidentInfo",
  //     data
  //   );
  //   return result;
  // };

  saveDeliverersInfo = (payload: any) => {
    return commonDataAccess.postData("Deliverer/save/", payload);
  };

  getDelivererById = async (id: number) => {
    return await commonDataAccess.getData(`Deliverer/getById/${id}`, {});
  };


  deleteDelivererInfo = (ids: number | number[]) =>{
    if(Array.isArray(ids)){
      return commonDataAccess.postData("Deliverer/deleteAll", ids);
    }else{
      return commonDataAccess.deleteData(`Deliverer/delete/${ids}`);
    }
  }

}


export default new delivererDataAccess();
